import { PhoneCall, ClipboardList, Stethoscope } from "lucide-react";
import HomeMakerImg from "../assets/HomeCare.jpg";
import PersonalCareImg from "../assets/CCPProgram.jpg";
import CompanionshipImg from "../assets/CompanionShip.jpg";

export default function PrivateHomeCare() {
  return (
    <div className="bg-gray-50">   
      {/* ✅ BENEFITS SECTION */}
      <section className="py-12 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">
          Benefits at AllWell Companion Home Care
        </h2>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {/* ✅ Consultation */}
          <div className="text-center">
            <PhoneCall size={50} className="text-emerald-600 mx-auto" />
            <h3 className="text-xl font-semibold mt-2">Consultation</h3>
            <p className="text-gray-600 text-sm">
              Helping clients understand their home care needs.
            </p>
          </div>

          {/* ✅ Plan of Care */}
          <div className="text-center">
            <ClipboardList size={50} className="text-emerald-600 mx-auto" />
            <h3 className="text-xl font-semibold mt-2">
              Developing a Plan of Care
            </h3>
            <p className="text-gray-600 text-sm">
              Personalized care plans designed for individual needs.
            </p>
          </div>

          {/* ✅ Monitoring */}
          <div className="text-center">
            <Stethoscope size={50} className="text-emerald-600 mx-auto" />
            <h3 className="text-xl font-semibold mt-2">Monitor & Managing</h3>
            <p className="text-gray-600 text-sm">
              Ongoing supervision to ensure care is effective.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ WHAT WE OFFER SECTION */}
      <section className="py-12 bg-white text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">What We Offer</h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* ✅ Home Maker Services */}
          <div className="p-4 shadow-md rounded-lg bg-gray-50 hover:shadow-lg transition-shadow duration-300">
            <img
              src={HomeMakerImg}
              alt="Home Maker"
              className="w-full rounded-md transform transition-transform duration-300 hover:scale-105"
            />
            <h3 className="mt-3 text-lg font-semibold">Home Support Services </h3>
            <ul className="list-disc list-inside mt-2 text-gray-700 text-left">
              <li>Cooking & Meal Preparation</li>
              <li>Light Housekeeping</li>
              <li>Laundry & Ironing</li>
              <li>Grocery Shopping & Errands</li>
              <li>Bed making & Linen Changing</li>
            </ul>
          </div>

          {/* ✅ Personal Care Services */}
          <div className="p-4 shadow-md rounded-lg bg-gray-50 hover:shadow-lg transition-shadow duration-300">
            <img
              src={PersonalCareImg}
              alt="Personal Care"
              className="w-full rounded-md transform transition-transform duration-300 hover:scale-105"
            />
            <h3 className="mt-3 text-lg font-semibold">
            Personal Care Assistance
            </h3>
            <ul className="list-disc list-inside mt-2 text-gray-700 text-left">
              <li>Bathing & Dressing Assistance</li>
              <li>Help with Toileting</li>
              <li>Medication Reminders</li>
              <li>Mobility Support</li>
            </ul>
          </div>

          {/* ✅ Companionship Services */}
          <div className="p-4 shadow-md rounded-lg bg-gray-50 hover:shadow-lg transition-shadow duration-300">
            <img
              src={CompanionshipImg}
              alt="Companionship"
              className="w-full rounded-md transform transition-transform duration-300 hover:scale-105"
            />
            <h3 className="mt-3 text-lg font-semibold">
            Companionship & Social Engagement
            </h3>
            <ul className="list-disc list-inside mt-2 text-gray-700 text-left">
              <li>Friendly Conversation</li>
              <li>Playing Games or Reading Together</li>
              <li>Accompanying to Appointments</li>
              <li>Providing Emotional Support</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
